const pricingData = [
  {
    id: 1,
    package: "Basic",
    price: "₹25,000",
    duration: "6 Hours",
    features: [
      "1 photographer",
      "300+ edited photos",
      "Basic album",
      "Same day preview"
    ],
    notIncluded: ["Video coverage", "Drone shots", "Extra photographer"]
  },
  {
    id: 2,
    package: "Standard",
    price: "₹45,000",
    duration: "10 Hours",
    features: [
      "2 photographers",
      "600+ edited photos",
      "Premium album",
      "Same day preview",
      "Video coverage"
    ],
    notIncluded: ["Drone shots", "Extra photographer"]
  },
  {
    id: 3,
    package: "Premium",
    price: "₹75,000",
    duration: "Full Day",
    features: [
      "3 photographers",
      "1000+ edited photos",
      "Luxury album",
      "Same day preview",
      "Video coverage",
      "Drone shots",
      "Pre-wedding shoot"
    ],
    notIncluded: []
  }
];

export default pricingData;
